const readFirebaseConfig = prefix => ({
  apiKey: process.env[`${prefix}_API_KEY`],
  authDomain: process.env[`${prefix}_AUTH_DOMAIN`],
  projectId: process.env[`${prefix}_PROJECT_ID`],
  storageBucket: process.env[`${prefix}_STORAGE_BUCKET`],
  messagingSenderId: process.env[`${prefix}_MESSAGING_SENDER_ID`],
  appId: process.env[`${prefix}_APP_ID`],
});

const mergeFirebaseConfig = (label, primary, fallback) => {
  const missingKeys = Object.keys(fallback).filter(key => !primary[key]);
  if (missingKeys.length > 0 && missingKeys.length < Object.keys(fallback).length) {
    // Partial config — a likely typo. Loud warning, since auth will silently
    // route to the wrong Firebase project for some fields.
    // eslint-disable-next-line no-console
    console.warn(
      `[firebase config] ${label} is partially configured. Missing: ${missingKeys.join(', ')}. ` +
        `Falling back to the user Firebase project for those fields — check your REACT_APP_${label.toUpperCase()}_FIREBASE_* vars.`
    );
  }
  return Object.fromEntries(
    Object.keys(fallback).map(key => [key, primary[key] || fallback[key] || undefined])
  );
};

export const USER_FIREBASE_CONFIG = readFirebaseConfig('REACT_APP_FIREBASE');
export const PROFESSIONAL_FIREBASE_CONFIG = mergeFirebaseConfig(
  'professional',
  readFirebaseConfig('REACT_APP_PROFESSIONAL_FIREBASE'),
  USER_FIREBASE_CONFIG
);
export const ADMIN_FIREBASE_CONFIG = mergeFirebaseConfig(
  'admin',
  readFirebaseConfig('REACT_APP_ADMIN_FIREBASE'),
  USER_FIREBASE_CONFIG
);

// Backward-compatible alias for the event booker app.
export const FIREBASE_CONFIG = USER_FIREBASE_CONFIG;

